export default window.PDFNet.Obj.Type;
